import { Relato } from "../components/FormRelato/type"

export function sortReportes(reportes: Relato[]) {
  reportes.sort((a: Relato, b: Relato) => {
    let ra = (a.requer_atencao ? 0 : 1) - (b.requer_atencao ? 0 : 1)
    let ro = (a.reporte_obrigatorio ? 0 : 1) - (b.reporte_obrigatorio ? 0 : 1)
    return ra || ro || a.atualizado_em?.localeCompare(b.atualizado_em || '')
  })
}

export function requerAtencao(reportes: Relato[]): boolean {
  return reportes.findIndex(r => r.requer_atencao) !== -1
}

export function tamanhoMaiorSigla(itens: { reportes: Relato[] }[]): number {
  const rep = itens.map(
    item => item.reportes
  ).flat()

  return rep.length
    ? rep.map(
      r => (r.sigla_departamento || '').length
    ).reduce(
      (a, b) => Math.max(a, b)
    )
    : 0
}
